import { theme } from '@kvdbil/components';
import { TranslateFunction } from '~/Locale';
import { getMainCategoryFromPath } from '~/helpers/filterTranslation';
import { CategoryOption } from '../../types/FilterSearchParam';

export const objectSearchFieldOptionStyle = (
  isSelected: boolean,
  isFocused: boolean
) => {
  const selectedColor = theme.colors.text.light;
  const selectedBackground = theme.colors.info.main;
  const focusedBackground = theme.colors.background.gray;

  const getBackgroundColor = () => {
    if (isSelected) return selectedBackground;
    if (isFocused) return focusedBackground;
    return 'none';
  };

  return {
    color: isSelected ? selectedColor : theme.colors.text.dark,
    background: getBackgroundColor(),
    '&:hover': {
      background: isSelected ? selectedBackground : focusedBackground
    },
    paddingLeft: '1.5rem',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  };
};

export const getDefaultCategoryOption = (
  t: TranslateFunction,
  path: string,
  categoryOptions: CategoryOption[]
) => {
  const mainCategory = getMainCategoryFromPath(path, t);
  const categoryOption = categoryOptions.find(
    ({ value }) => value === mainCategory
  );

  return categoryOption ?? categoryOptions[0];
};
